<app-page-shell variant="wizard" [stickyChrome]="true" [withOps]="true">
  <div pageChrome>
    <app-status-bar [isShowStatusBar]="campaign.value.status === 'draft' || launchType === 'relaunch'" [skipLanding]="campaign.value?.landing_page_status === 'skipped'" [step]="step" (SaveButtonClick)="onSaveButtonClick()" [reLaunch]="launchType === 'relaunch'" [campaign]="this.campaign.value"></app-status-bar>
  </div>
<div>

      <div class="card card-box">
        <div class="card-header py-3">
          <div class="card-header--title font-size-lg">
            {{launchStatus === 'done' && launchType !== 'relaunch' ? getLaunchedMessage():'Mobilize Your Influencers'}}
            @if (campaign.value.status === 'launch_failed') {
            <span><app-info-popover info="{{ campaign.value.status_message }}"></app-info-popover></span>
            }
            @if (campaign.value?.status === 'launch_scheduled' && currentUser?.timezone) {
            <span><app-info-popover info="{{ getCampaignTZDate() }}"></app-info-popover></span>
            }
          </div>
          <div class="card-header--actions pull-right">
          </div>
        </div>
        <div class="card-body p-0">
          @if (!launchStatus || launchType === 'relaunch') {
          <div class="row p-5">
            <div class="col-5">
              <div class="col-12 p-3">
                <div class="col-md-12 col-sm-12">
                  <div class="timeline-list mb-5 timeline-list--first">
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper influencerImg rounded-pill text-white">
                          @if (doTheSegmentHaveInfluencers) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold">Influencers Selected. Check</h4>
                          <button class="btn" (click)="redirect('influencer')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (doTheSegmentHaveInfluencers && !doTheSegmentHaveInfluencersLoading) {
                        <p>
                          {{launchType !== 'relaunch' ? influencerCount : totalRelaunchInfluencerCount}} {{influencerType?influencerType:''}} will spread the word about the
                          {{(campaign.value$ | async)?.project.title || 'project'}}@if (launchType === 'relaunch' && campaign.value.email_disabled !== 'true') { ({{newInfluencerCount}} new {{influencerType?influencerType:''}} + {{campaignEmailInfluencerCount}} existing {{influencerType?influencerType:''}} that haven't received email yet)}.
                        </p>
                        }
                        @if (doTheSegmentHaveInfluencers && !doTheSegmentHaveInfluencersLoading && campaign.value.email_disabled === 'true') {
                        <p class="text-primary">
                          IMPORTANT: You selected the 'No Email' option on the previous page, therefore, zero participants will receive this message upon launch.
                        </p>
                        }
                        @if (!doTheSegmentHaveInfluencers && !doTheSegmentHaveInfluencersLoading) {
                        <p
                          class="text-danger">
                          Influencers not available for selected segment.
                        </p>
                        }
                        @if (doTheSegmentHaveInfluencersLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    @if (!isLandingPageSkipped) {
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper landingImg rounded-pill text-white">
                          @if (isLandingPageSet) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold">Landing Pages Personalized. Check </h4>
                          <button class="btn" (click)="redirect('template')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (isLandingPageSet && !isLandingPageSetLoading) {
                        <p>
                          Your influencers unique personalized landing pages are ready.
                        </p>
                        }
                        @if (!isLandingPageSet && !isLandingPageSetLoading) {
                        <p class="text-danger">
                          No landing pages have been created for the selected segment.
                        </p>
                        }
                        @if (isLandingPageSetLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper landingImg rounded-pill text-white">
                          @if (isSocialPageSet) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold">Social Share Customized. Check </h4>
                          <button class="btn" (click)="redirect('socialShare')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (isSocialPageSet && !isSocialPageSetLoading) {
                        <p>
                          Your influencers social share personalized and is ready.
                        </p>
                        }
                        @if (!isSocialPageSet && !isSocialPageSetLoading) {
                        <p class="text-danger">
                          No social share customized.
                        </p>
                        }
                        @if (isSocialPageSetLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    @if (showEmailCustomize && sendsEmail) {
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper emailImg rounded-pill text-white">
                          @if (isCampaignTemplateSet) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                          @if (!isCampaignTemplateSet) {
                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                          }

                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold">The ASK EMAIL. Check.</h4>
                          <button class="btn" (click)="redirect('email')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (isCampaignTemplateSet && !isCampaignTemplateSetLoading) {
                        <p>
                          Your email to your influencers is created and ready to go.
                        </p>
                        }
                        @if (!isCampaignTemplateSet && !isCampaignTemplateSetLoading) {
                        <p class="text-danger">
                          Your domain is not verified. <a class="cursor-pointer"
                            (click)="resendMail()"><u>Click here</u></a> to verify and get instructions.
                        </p>
                        }
                        @if (isCampaignTemplateSetLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                    @if (!allow_campaign_to_launch_when_registration_widget_is_disabled) {
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper emailImg rounded-pill text-white">
                          @if (isWidgetActive) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                          @if (!isWidgetActive) {
                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                          }

                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold">Registration Widget should be active. Check</h4>
                          <button class="btn" (click)="redirect('widget')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (isWidgetActive && !isCampaignTemplateSetLoading) {
                        <p>
                          Your Registration Widget is activated and ready to go.
                        </p>
                        }
                        @if (!isWidgetActive && !isCampaignTemplateSetLoading) {
                        <p class="text-danger">
                          Your Registration Widget is not activated. <a class="cursor-pointer"
                                                          (click)="redirect('widget')"><u>Click here</u></a> to active and get instructions.
                        </p>
                        }
                        @if (isCampaignTemplateSetLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    }

                    @if (!allow_campaign_to_launch_when_registration_widget_is_disabled) {
                    <div class="timeline-item timeline-item-icon">
                      <div class="timeline-item--content">
                        <div class="timeline-item--icon-wrapper emailImg rounded-pill text-white">
                          @if (!isWidgetPublicAccess) {
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          }
                          @if (isWidgetPublicAccess) {
                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                          }

                        </div>
                        <div class="d-flex">
                          <h4 class="timeline-item--label mb-2 fw-bold"> Registration Widget should be publicly accessible. Check</h4>
                          <button class="btn" (click)="redirect('widget')">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (!isWidgetPublicAccess && !isCampaignTemplateSetLoading) {
                        <p>
                          Your Registration Widget is  publicly accessible and ready to go.
                        </p>
                        }
                        @if (isWidgetPublicAccess && !isCampaignTemplateSetLoading) {
                        <p class="text-danger">
                          Your Registration Widget not publicly accessible <a class="cursor-pointer"
                                                          (click)="redirect('widget')"><u>Click here</u></a> and disable Limit access for testing purpose
                        </p>
                        }
                        @if (isCampaignTemplateSetLoading) {
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="col-7 d-flex justify-content-center align-items-center">
              <img class="img-fluid rounded" src="../../../../assets/images/launchimage.png" alt="lauchImg" />
            </div>
          </div>
          }
          @if (launchStatus || launchType === 'relaunch') {
          <div class="row p-5" style="text-align: center">
            @if (launchStatus === 'start') {
            <div class="col-12">
              <div style="margin-bottom: -30px;">
                <span>Launching in progress</span>
              </div>
            </div>
            }
            @if (launchStatus === 'start') {
            <div class="col-12">
              <div class="lds-ellipsis" style="margin-left: -40px">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            }
            @if (launchStatus === 'done' && launchType !== 'relaunch') {
            <div class="col-12">
              <button class="btn btn-primary me-2" (click)="redirect('statistics')">View Report</button>
              <button class="btn btn-primary" type="button"
              [routerLink]="'/' + routes.createCampaign({projectId: $safeNavigationMigration((campaign.value$ | async)?.project_id)})" role="button">
              <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
              <span class="btn-wrapper--label">Start a New Campaign</span>
            </button>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
</app-page-shell>

<div class="operation-box">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6">
        <div class="text-start">
          @if (!launchStatus || launchType === 'relaunch') {
          <button (click)="redirect('email')" class="btn btn-default me-2 stopclick float-start"
            type="button">
            Back
          </button>
          }
        </div>
      </div>
      <div class="col-md-6">
        <div class="text-end">
<!--          <button-->
<!--            class="btn btn-default mr-2"-->
<!--            type="button">-->

          @if (!launchStatus || launchType === 'relaunch') {
          <button
            [disabled]="!(doTheSegmentHaveInfluencers && (showEmailCustomize ? isCampaignTemplateSet : true) && isLandingPageSet) || (loader$ | async) || (!allow_campaign_to_launch_when_registration_widget_is_disabled && !isWidgetActive) ||  (!allow_campaign_to_launch_when_registration_widget_is_disabled && isWidgetPublicAccess)"
            class="btn btn-default"
            [class.me-2]="!schedule?.schedule_date"
            (click)="launchScheduledCampaign()"
            type="button"
          >
            <span>
              @if (loader$ | async) {
              <i class="fa fa-spinner fa-spin me-2"></i>
              }
              {{launchType === 'relaunch' ? 'Schedule ReLaunch' : schedule?.schedule_date && schedule?.schedule_time ? 'Schedule to Launch at ' + getScheduleDateTime() : 'Schedule Launch' }}
            </span>
          </button>
          }
          @if (schedule?.schedule_date && schedule?.schedule_time) {
          <span class="me-3"><app-info-popover info="{{ getScheduleDateTime(true) }}"></app-info-popover></span>
          }

          @if (!launchStatus || launchType === 'relaunch') {
          <button (click)="openLaunchConfirmationModal()"
            [disabled]="!(doTheSegmentHaveInfluencers && (showEmailCustomize ? isCampaignTemplateSet : true) && isLandingPageSet) || (loader$ | async) || (!allow_campaign_to_launch_when_registration_widget_is_disabled && !isWidgetActive) ||  (!allow_campaign_to_launch_when_registration_widget_is_disabled && isWidgetPublicAccess)"
            class="btn btn-primary float-end me-2" type="button">
            <span>@if ((loader$ | async)) {
<i class="fa fa-spinner fa-spin me-2"></i>
}{{launchType === 'relaunch' ? 'ReLaunch' : 'Launch'}}</span>
          </button>
          }

        </div>
      </div>
    </div>
  </div>
</div>
